// extracted by mini-css-extract-plugin
export default {"host":"style_host__BBvY5","table":"style_table__4T47q","link":"style_link__7HSd-"};